/**
 * All global providers required by ONE app to work
 */

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import AuthProvider from 'components/authentication/provider/AuthProvider';
import WizardOpeningProvider from 'components/common/wizard/WizardOpeningProvider';
import { ReactNode } from 'react';
import { Provider } from 'react-redux';
import type { AnyAction, Store } from 'redux';

type AppProviderProps = { children: ReactNode; store: Store<$TSFixMe, AnyAction>; queryClient: QueryClient };

const AppProvider = ({ children, store, queryClient }: AppProviderProps) => (
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <AuthProvider>
        <WizardOpeningProvider>{children}</WizardOpeningProvider>
      </AuthProvider>
    </Provider>
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);

export default AppProvider;
